<template>
        <!-- 車辨系統 -->
        <div class="car-ana">
            <BOverlay
                variant="white"
                :show="sys.showLoading"
                spinner-variant="primary"
                blur="0"
                opacity=".75"
                rounded="sm"
            >
                <PictureAnalysis
                    :sys="sys.turn"
                    @change="sys.anaChange"
                />
                <BCard
                    class="mt-2"
                >
                    <BRow>
                        <BCol>
                            <BFormGroup
                                class="w-100 mt-2"
                                label="車牌號碼"
                                label-for="car-board"
                            >
                                <BFormInput
                                    id="car-board"
                                    placeholder=""
                                    :state=sys.state
                                    v-model="sys.data"
                                    @blur="sys.search()"
                                    inputmode="text"
                                />
                            </BFormGroup>

                            <BFormGroup
                                v-if="sys.next"
                                class="w-100 mt-2"
                                label="eTag 編號"
                                label-for="etag"
                            >
                                <BFormInput
                                    id="etag"
                                    placeholder=""
                                    v-model="sys.etag"
                                    ref="etag"
                                    inputmode="text"
                                />
                            </BFormGroup>
                        </BCol>
                    </BRow>
                    <BRow v-if="sys.next">
                        <BCol>
                            <BButton 
                                class="w-100 text-white"
                                variant="gradient-success"
                                @click="sys.submit" 
                            >
                                送出
                            </BButton>
                        </BCol>
                        <!-- <BCol>
                            <BButton 
                                class="w-100 text-white"
                                variant="gradient-danger"
                                @click="sys.clear" 
                            >
                                清除
                            </BButton>
                        </BCol> -->
                    </BRow>
                </BCard>
            </BOverlay>
        </div>
</template>
<script>
import { nextTick, getCurrentInstance, reactive, onMounted, ref, watch } from '@vue/composition-api'
import api from './js/api.js'
import Toast from './js/Toast'
import PictureAnalysis from '@/components/other/PictureAnalysis/PictureAnalysis.vue'
import { BCard, BButton, BRow, BCol, BFormInput, BFormGroup, BOverlay } from 'bootstrap-vue'
import { async } from 'q'
export default {
    name: 'Unitsys',
    components: {
        BButton,
        BRow,
        BCol,
        BFormInput,
        BFormGroup,
        BCard,
        PictureAnalysis,
        BOverlay
    },
    setup(props, ctx) {
        const vue = getCurrentInstance()
        const toast = new Toast()
        const sys = reactive({
            showLoading: false,
            data: '', // 車牌
            etag: '', // etag
            search: async ()=>{
                sys.showLoading = true
                await sysApi.haveData(sys, sys.data)
                sys.showLoading = false
                nextTick(()=>{
                    sysDom.CanFocus(vue.refs.etag)
                })
            },
            anaChange: async (text)=>{
                sys.data = text
                sys.showLoading = true
                await sysApi.haveData(sys, sys.data)
                sys.showLoading = false
                nextTick(()=>{
                    sysDom.CanFocus(vue.refs.etag)
                })
            },
            submit: async ()=>{
                sys.showLoading = true
                await sysApi.update(sys)
                sys.clear()
                sys.showLoading = false
            },
            clear: ()=>{
                sys.data = ''
                sys.etag = ''
                sys.state = null
                sys.next = false
            },
            turn: false,
            state: null,
            next: false
        })

        const sysDom = {
            CanFocus: (el)=>{
                if(sys.state){
                    el.focus()
                }
            }
        }

        const sysApi = {
            carParkNo: '',
            carParkSer: 0,
            haveData: (obj, CarNumber)=>{
                return new Promise((r, j)=>{
                    api.CarSearch(sys.data.replace('-', '')).then(res=>{
                        const have = res.Found
                        sysApi.carParkNo = res.CarParkNo
                        sysApi.carParkSer = res.CarParkSer
                        // console.log(res)
                        obj.state = have
                        obj.next = have
                        r()
                    })
                })
            },
            update: (obj)=>{
                // 資料庫綁定
                api.CarETagBinding(sysApi.carParkNo, sysApi.carParkSer, obj.etag).then(p=>{
                    // 吐司(成功綁定訊息)
                    toast.toastSuccess('綁定成功')
                })
            }
        }

        return {
            sys,
        }
    }
}
</script>
<style lang="scss">
.car-ana {
    
}
</style>